var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercardPayment = function SvgMastercardPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M23.972 20.067h-7.16V7.28h7.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M17.271 13.673a8.1 8.1 0 0 1 3.126-6.394 8.18 8.18 0 0 0-5.058-1.739c-4.519 0-8.182 3.641-8.182 8.133s3.663 8.132 8.182 8.132a8.18 8.18 0 0 0 5.058-1.739 8.1 8.1 0 0 1-3.126-6.393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M33.63 13.673c0 4.491-3.664 8.132-8.183 8.132a8.2 8.2 0 0 1-5.058-1.739 8.1 8.1 0 0 0 0-12.787 8.2 8.2 0 0 1 5.058-1.739c4.519 0 8.182 3.641 8.182 8.133Z"
  })));
};
export default SvgMastercardPayment;